import { useMutation, gql } from "@apollo/client"
import { LIBRARY_TEMPLATE_FIELDS } from "./useQueryLibraryTemplates"

const USELIBRARYTEMPLATE_MUTATION = gql`
  mutation UseLibraryTemplate($id: ID!) {       
      useLibraryTemplate(id: $id) {
        ... on Process {
          __typename
          ${LIBRARY_TEMPLATE_FIELDS}
        }    
      } 
  }
`

const useMutationUseLibraryTemplate = () => useMutation(USELIBRARYTEMPLATE_MUTATION)

export { useMutationUseLibraryTemplate }
